@if (state$ | async; as state) {
  <div>
    <h1 class="c-h1">{{'FINANCIAL.contributions' | translate}}</h1>
    <section class="u-margin-top-l">
      <myabvv-contributions-overview
        [contributionYears]="state.data?.memberShips?.contributionYears"
        [memberShipFees]="state.data?.memberShipFees"
        [hasHiddenPreEuroYears]="state.data?.hasHiddenPreEuroYears ?? false"
        [isLoading]="state.loading">
      </myabvv-contributions-overview>

      @if (state.loading) {
        <myabvv-loader [message]="'GENERAL.busy_loading' | translate"></myabvv-loader>
      }
    </section>
  </div>
}
